import React from "react";
import { StyledButton } from "./ButtonConfirm.style";
import Loader from "@components/Loader/Loader";

const CustomizedButton = ({
  isCreating,
  handleCreate,
  creatingText,
  finalizeText,
  bgColor,
  icon,
  stylee,
  className,
}) => {
  return (
    <StyledButton
      className={className || "btn"}
      type="submit"
      sx={{ ...stylee }}
      disabled={isCreating}
      onClick={handleCreate}
      bgColor={bgColor}
      startIcon={icon ? icon : null}>
      {isCreating ? <Loader /> : finalizeText}
    </StyledButton>
  );
};

export default CustomizedButton;
